import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BadgeModule } from '../badge/badge.module';
import { AvatarComponent } from './components/avatar.component';

@NgModule({
    imports: [
        CommonModule,

        BadgeModule,
    ],
    declarations: [
        AvatarComponent,
    ],
    exports: [
        AvatarComponent,
    ],
})

export class AvatarModule {}
